VjsAdmin.Roles = (function () {
    const init = function () {};

    return {
        init,
    };
}());
